module.exports = __webpack_public_path__ + "img/empty-list.5f092d3b.svg";